import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IConnectedDevice } from '../types/IConnectedDevice';
import { IGetItemsResult } from '../types/IGetItemsResult';

export interface IGetUserConnectedDevicesParams {
  userId: string;
}

export interface IGetUserConnectedDevicesResult extends IGetItemsResult {
  devices: IConnectedDevice[];
}

export class GetUserConnectedDevicesRequest extends Request<IGetUserConnectedDevicesParams, IGetUserConnectedDevicesResult> {
  constructor(params: IGetUserConnectedDevicesParams) {
    super('getUserConnectedDevices', params);
  }
}
